// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"304df09b","88":"d25b9ea5","153":"c862e9a6","278":"9e8e02cf","704":"f9119355","755":"769f8547","774":"6415c182","868":"84f9ff08","941":"97a59715"}[chunkId] + ".chunk.js";
};